// components/onboarding/tourSteps.js
// import dashboardGif from '../../assets/img/onboarding_images/Dashboard.gif'; //TODO: Import and use the GIF when the GIF is ready and approved for use

export const getTourSteps = (t) => [
  {
    element: '[data-tour="tour-dashboard"]',
    popover: {
      title: t('onboardingTour.dashboard.title'),
      description: t('onboardingTour.dashboard.description'),
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="tour-relations"]',
    popover: {
      title: t('onboardingTour.relations.title'),
      description: t('onboardingTour.relations.description'),
      // imageUrl:dashboardGif, //TODO: Uncomment and use the imported GIF
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="tour-proposals"]',
    popover: {
      title: t('onboardingTour.proposals.title'),
      description: t('onboardingTour.proposals.description'),
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="tour-planning"]',
    popover: {
      title: t('onboardingTour.planning.title'),
      description: t('onboardingTour.planning.description'),
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="tour-users"]',
    popover: {
      title: t('onboardingTour.users.title'),
      description: t('onboardingTour.users.description'),
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="tour-invoices"]',
    popover: {
      title: t('onboardingTour.invoices.title'),
      description: t('onboardingTour.invoices.description'),
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="tour-hoursRegistration"]',
    popover: {
      title: t('onboardingTour.hoursRegistration.title'),
      description: t('onboardingTour.hoursRegistration.description'),
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="tour-myLeaves"]',
    popover: {
      title: t('onboardingTour.myLeaves.title'),
      description: t('onboardingTour.myLeaves.description'),
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="tour-profile"]',
    popover: {
      title: t('onboardingTour.profile.title'),
      description: t('onboardingTour.profile.description'),
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="tour-notifications"]',
    popover: {
      title: t('onboardingTour.notifications.title'),
      description: t('onboardingTour.notifications.description'),
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="tour-support"]',
    popover: {
      title: t('onboardingTour.support.title'),
      description: t('onboardingTour.support.description'),
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="tour-location"]',   
    popover: {
      title: t('onboardingTour.location.title'),
      description: t('onboardingTour.location.description'),
      side: 'bottom',
      align: 'end',
    },
  },
  {
  element: '[data-tour="tour-retake"]',
  popover: {
    title: t('onboardingTour.retake.title'),
    description: t('onboardingTour.retake.description'),
    side: 'bottom',
    align: 'end',
  },
},
];